import { ReactNode, useEffect, useMemo } from 'react';
import { useCellulaProviderContext } from '../../provider/cellula_provider.context';
import { CSSDOMRenderer } from './_css_dom_renderer';
import { LayoutContext } from './layout_provider.context';

interface Props {
	children: ReactNode;
}

export function LayoutProvider({ children }: Props): JSX.Element {
	const { cellulaId } = useCellulaProviderContext();
	const cssDomRenderer = useMemo(() => new CSSDOMRenderer(cellulaId), [cellulaId]);

	cssDomRenderer.QUIRK_HACK_TO_BE_USED_IN_RENDER_BODY();

	useEffect(() => {
		cssDomRenderer.create();

		return () => {
			// Avoid the clean up for now. We'll just use one CSSDOMRenderer for the
			// application to avoid style interferences.
			cssDomRenderer.remove();
		};
	}, [cssDomRenderer]);

	return <LayoutContext.Provider value={cssDomRenderer}>{children}</LayoutContext.Provider>;
}
